import Defs from '../../../../includes/primitives/colorDefs'

export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))

      let json = JSON.parse(JSON.stringify(this.JQueries))


      this.sundries  = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters


      
    },

  }
}